import {
  VersionControllerClient,
  WorkflowVersion
} from '@foxden/version-controller-client';

import { PaymentClient } from '../backend-client/paymentBackend';

const getTermsUrl = (baseTermsUrl: string, applicationGroupId: string) => {
  const normalizedBaseUrl = baseTermsUrl.replace(/\/+$/, '');
  return `${normalizedBaseUrl}/terms/${applicationGroupId}`;
};

/**
 * Build the T&C (terms) URL. The path carries the `applicationGroupId` so a
 * single link covers every LOB in the group. The payment-frontend version is
 * taken from the `versionData` already resolved on the Quote page — no extra
 * version lookup is needed.
 */
export function getVersionedTermsUrl(
  applicationGroupId: string,
  versionData: WorkflowVersion
): string {
  const baseUrl = PaymentClient.getPaymentFrontendURL(
    versionData.paymentFrontendVersion
  );
  return getTermsUrl(baseUrl, applicationGroupId);
}

const getCompleteUrl = (baseCompleteUrl: string, invoiceId: string) => {
  const normalizedBaseUrl = baseCompleteUrl.replace(/\/+$/, '');
  return `${normalizedBaseUrl}/complete/${invoiceId}`;
};

export async function getVersionedCompleteUrl(
  applicationId: string,
  invoiceId: string,
  versionControllerClient: VersionControllerClient
): Promise<string> {
  const version = await versionControllerClient.getVersionFromApplication(
    applicationId
  );
  const baseUrl = PaymentClient.getPaymentFrontendURL(
    version.paymentFrontendVersion
  );
  return getCompleteUrl(baseUrl, invoiceId);
}
